import { emulatorScreen, mobileScreen } from "../../utils/styleUtils";

const styles = (theme) => ({
  homeScreenContainer: {
    height: "100%",
    backgroundColor: "#ecf2f1",
    paddingTop: 30,
    [mobileScreen(theme)]: {
      paddingTop: 10,
    },
  },

  homeMainScreenContainer: {
    height: '100%',
    position: 'relative',
    minHeight: '100vh',
    backgroundColor: '#ecf2f1',
    [mobileScreen(theme)]: {
      // padding: "1rem",
      minHeight: 'auto',
    },
  },

  homeTitle: {
    color: "#003e4c",
    fontFamily: "Oswald",
    fontSize: "3rem",
    fontWeight: "500",
    [mobileScreen(theme)]: {
      fontSize: "1.5rem",
    },
  },

  homeQuestion: {
    color: "#003e4c",
    fontFamily: "Oswald",
    fontSize: "2rem",
    fontWeight: "500",
    [mobileScreen(theme)]: {
      fontSize: "16px",
    },
  },

  gdpIcon: {
    width: "550px",
    height: "230px",
    margin: "50px 0",
    [mobileScreen(theme)]: {
      width: "210px",
      height: "80px",
      margin: "12px 0",
    },
  },

  playButton: {
    backgroundColor: "#00b1d9",
    color: "#fff",
    fontSize: "36px",
    fontWeight: "500",
    padding: "0 50px",
    borderRadius: "0",
    // lineHeight: "1.4",
    margin: "24px 0",
    fontFamily: "'Oswald', sans-serif",
    "&:hover": {
      backgroundColor: "#056f8a",
    },
    [mobileScreen(theme)]: {
      padding: "0 24px",
      fontSize: "20px",
      margin: "15px 0",
    },
  },

  // mruLogo: {
  //   alignItems: "flex-end",
  //   display: "flex",
  // },

  // mruLogoContainer: {
  //   height: "8vh",
  // },


  forTeachers: {
    // position: "absolute",
    marginTop: -25,
    display: 'flex',
    alignItems: 'flex-end',
    padding: "15px",
    // backgroundColor: "#fff",
    [emulatorScreen(theme)]: {
      marginTop: 15,
    },
    [mobileScreen(theme)]: {
      marginTop: 0,
      // paddingTop: 0,
    },
  },

  forStudentsTitle: {
    color: "#003e4c",
    fontWeight: "500",
    fontSize: "1.5rem",
    fontFamily: "'Oswald',sans-serif",
    [emulatorScreen(theme)]: {
      fontSize: "1rem",
    },
    [mobileScreen(theme)]: {
      fontSize: "0.7rem",
    },
  },

  linkImg: {
    width: "30px",
    [emulatorScreen(theme)]: {
      width: "20px",
    },
    [mobileScreen(theme)]: {
      width: "10px",
    },
  },

  sideBarLinkText: {
    fontFamily: "'Oswald'",
    fontSize: "16px",
    marginLeft: "12px",
    fontWeight: "500",
    color: "#003e4c",
    lineHeight: 1.1,
    [emulatorScreen(theme)]: {
      fontSize: "12px",
      lineHeight: "1",
    },
    [mobileScreen(theme)]: {
      fontSize: "10px",
      lineHeight: "1",
    },
  },

  sideBarLink: {
    display: "flex",
    alignItems: "center",
    marginTop: "15px",
    cursor: "pointer",
    textDecoration: "none!important",
    [emulatorScreen(theme)]: {
      marginTop: "8px",
    },
    [mobileScreen(theme)]: {
      marginTop: "6px",
    },
  },

  mruLogo: {
    alignItems: "flex-end",
    padding: "2rem",
    display: "flex",
    [mobileScreen(theme)]: {
      padding: "1rem",
    },
  },

  logoImg: {
    width: "110px",
    cursor: 'pointer',
    [mobileScreen(theme)]: {
      width: "80px",
    },
  },
});

export default styles;
